import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { demoDare } from "./demoDareAPI";

const initialState = {
    status: "idle",
    NewQuestion:'',
    NewQuestionTimer: '',
    DrinkQuestion: '',
    Attributes: [],
    Accessories:[],
    UsedQuestionsId:[],
    LastCard: false,
}

export const demoDareAsync = createAsyncThunk(
    "/demodare",
    async ({ gender, player }, { getState, rejectWithValue }) => {
        try {
            const state = getState();
            const usedid = state.demoDare.UsedQuestionsId;
            const selectedaccessories = state.demoDare.Accessories;
            const sessionid = state.gameStatus.sessions['demo'].sessionId



            const response = await demoDare(gender, player, usedid, selectedaccessories, sessionid);
            return response; // ✅ Ensure response is returned properly
        } catch (error) {
            console.error("Error in demoDareAsync:", error); // 👀 This should appear now
            return rejectWithValue(error.response
                ? { data: error.response.data, status: error.response.status }
                : { data: { error: "Unknown error" }, status: 500 })
        }
    }
);


export const demoDareSlice = createSlice({
    name: "demodare",
    initialState,
    reducers: {
        setAccessories: (state, action) =>{
            state.Accessories = action.payload
        },
        resetState:(state) =>{
            state.status ="idle"
            state.NewQuestion = ''
            state.NewQuestionTimer = ''
            state.DrinkQuestion = ''
            state.Attributes = []
            state.Accessories = []
            state.UsedQuestionsId =[]
            state.LastCard = false;
        },
    },
    extraReducers:(builder) => {
        builder
            .addCase(demoDareAsync.pending, (state) => {
                state.status = 'fetching';
            })
            .addCase(demoDareAsync.fulfilled, (state, action)=>{
                state.status ="fulfilled";
                state.NewQuestion = action.payload.question
                state.NewQuestionTimer = action.payload.timer
                state.DrinkQuestion = action.payload.drink
                state.UsedQuestionsId = [...state.UsedQuestionsId,action.payload.id]
                state.Attributes = [action.payload.attributes]
                state.LastCard = action.payload.last_card || false;
            })}})

export const selectDemoDare = (state) => state.demoDare
export const { setAccessories, resetState } = demoDareSlice.actions;
export default demoDareSlice.reducer